/**
 * Astoundify
 */
(function() {

	window.wp = window.wp || {};
	var document = window.document;
	var $ = window.jQuery;
	var wp = window.wp;

	/**
	 * @since 1.1.0
	 * @type {object}
	 */
	var self = Astoundify = _.extend( {}, {
		MobileDetect: new MobileDetect( window.navigator.userAgent )
	}, Astoundify || {} );

	/**
	 * Smooth scroll to an anchor on a page.
	 *
	 * @since 1.1.0
	 *
	 * @param {string} anchor
	 */
	self.scrollTo = function( anchor ) {
		var $anchor = $(anchor);

		$( 'html, body' ).animate({
				scrollTop: $anchor.offset().top
		}, 1000 );
	};

	/**
	 * Large-screen mobile touch events for the navigation bar.
	 *
	 * @since 1.0.0
	 */
	function largeScreenMobileTouch() {
		if ( ! Astoundify.MobileDetect.mobile() ) {
			return;
		}

		$( '#menu-store-toggle > a' ).on( 'click', function( e ) {
			e.preventDefault();
			console.log($(this));

			$(this).toggleClass( 'is-open' );
		});
	}

	/**
	 * Bind to the DOM
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {

		/**
		 * Smooth scroll trigger.
		 *
		 * @since 1.1.0
		 */
		$( '.js-trigger-scroll-to' ).on( 'click', function(e) {
			e.preventDefault();

			self.scrollTo( $(this).attr( 'href' ) );
		});

		/**
		 * @see http://mmenu.frebsite.nl/
		 */
		var navs = [ $( '#mobile-nav-helpdesk' ), $( '#mobile-nav' ) ];

		navs.forEach( function( nav ) {
			nav.mmenu({
				'navbar': {
					'add': false
				}
			});
		} );

		/**
		 * @see http://dotdotdot.frebsite.nl/
		 */
		$( '.truncate' ).dotdotdot({
			watch: true
		});

		/**
		 * If there is a current search term focus the searchform.
		 */
		if ( $( '#primary-search [type="search"]' ).val() ) {
			$( '#primary-search [type="search"]' ).focus();
		}

		largeScreenMobileTouch();

	});

})();
